import styled from 'styled-components'

export const StyledPage = styled.div`
	@media (min-width: 992px) {
		min-height: 800px;
		overflow-y: auto;
	}
`
